import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
import Main from '../containers/main';
import TokenResponse from '../containers/token-response';
import ConsoleRoutes from './console';

// import UnauthRoute from '../components/unauth-route';

class AppRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <Route exact={true} path='/' component={Main} />
          <AuthRoute path='/console' component={ConsoleRoutes} redirectTo='/' />
          <Route path='/auth/implicit/callback' component={TokenResponse} />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withRouter(connect(
  mapStateToProps
)(AppRoutes));




// WEBPACK FOOTER //
// ./src/routes/index.tsx